const TRREB_TAG = 'TRREB'
const RESTRICTED_LISTING_TAGS = [TRREB_TAG]

export const checkRestrictedListing = (tags: string[]) => {
  return tags?.some(tag => RESTRICTED_LISTING_TAGS.includes(tag))
}
